// extracted by mini-css-extract-plugin
module.exports = {"wallet":"Wallet_wallet__1EkUF","value":"Wallet_value__jhjTB"};